
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"74","height":"75","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.457 48.106c4.388 0 7.945-1.414 7.945-3.16 0-1.744-3.557-3.159-7.945-3.159s-7.945 1.415-7.945 3.16 3.557 3.16 7.945 3.16zM36.406 49.42c0 1.747-3.556 3.16-7.946 3.16s-7.948-1.42-7.948-3.16M36.406 53.892c0 1.746-3.556 3.16-7.946 3.16s-7.948-1.414-7.948-3.16","stroke":"#1BBAC8","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M36.406 44.937v13.41c0 1.747-3.556 3.16-7.946 3.16s-7.948-1.413-7.948-3.16v-13.41","stroke":"#1BBAC8","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M69.265 10.205H7.667a2.128 2.128 0 110-4.25h53.557a2.563 2.563 0 100-5.09H5.94A5.946 5.946 0 000 6.804v53.55a3.072 3.072 0 003.072 3.072H9.6a22.389 22.389 0 0037.843 0h21.803a3.072 3.072 0 003.072-3.072V13.277a3.071 3.071 0 00-3.053-3.072zM28.54 69.602a18.189 18.189 0 01-18.032-20.43 18.17 18.17 0 1118.032 20.43zm39.1-38.637H50.997a5.697 5.697 0 010-11.394H67.64v11.394zm-18.52-5.697a2.443 2.443 0 104.885 0 2.443 2.443 0 00-4.885 0z","fill":"#413E3E"}})])
          )
        }
      }
    